import { Box, Button, Grid, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import { Toast } from "../../components/Toast";

/**
 * Demonstration of Toast component showing the different toast types and variants
 */
const ToastDemo = () => {
  const colors = useColors();

  // Simple toast examples
  const showSimpleSuccess = () => {
    Toast.success("Operation completed successfully");
  };

  const showSimpleInfo = () => {
    Toast.info("New update is available");
  };

  const showSimpleWarning = () => {
    Toast.warning("This action may have consequences");
  };

  const showSimpleError = () => {
    Toast.error("An error occurred during the operation");
  };

  // Real-world examples from the codebase
  const showAsanaSuccess = () => {
    Toast.success({
      text: "Asana task created successfully!",
      recommended_action: "View",
      recommended_action_callback: () => {
        console.log("View task in Asana clicked");
      },
    });
  };

  const showJiraSuccess = () => {
    Toast.success({
      text: "Issue created successfully!",
      recommended_action: "View",
      recommended_action_callback: () => {
        console.log("View issue in Jira clicked");
      },
    });
  };

  // Complex toast examples with all options
  const showComplexSuccess = () => {
    Toast.success({
      text: "Operation completed successfully",
      content: "All resources were processed correctly",
      comment: "The system will update in the background",
      recommended_action: "View Details",
      unrecommended_action: "Dismiss",
      recommended_action_callback: () => console.log("View details clicked"),
      unrecommended_action_callback: () => console.log("Dismiss clicked"),
    });
  };

  const showScanSuccess = () => {
    Toast.success("Scan completed successfully");
  };

  const showScanInfo = () => {
    Toast.info("Scenarios scan in progress...");
  };

  const showScanFailed = () => {
    Toast.error("Scan failed");
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h6" gutterBottom>
        Simple Toasts (Text Only)
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <Button
            variant="contained"
            color="success"
            onClick={showSimpleSuccess}
          >
            Success
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={showSimpleInfo}>
            Info
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="warning"
            onClick={showSimpleWarning}
          >
            Warning
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="error" onClick={showSimpleError}>
            Error
          </Button>
        </Grid>
      </Grid>

      <Typography variant="h6" gutterBottom>
        Real-world Examples (From App)
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <Button variant="contained" color="success" onClick={showScanSuccess}>
            Scan Complete
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={showScanInfo}>
            Scan Progress
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="error" onClick={showScanFailed}>
            Scan Failed
          </Button>
        </Grid>
      </Grid>

      <Typography variant="h6" gutterBottom>
        Integration Examples (With Action Button)
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <Button
            variant="contained"
            color="success"
            onClick={showAsanaSuccess}
          >
            Asana Example
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={showJiraSuccess}>
            Jira Example
          </Button>
        </Grid>
      </Grid>

      <Typography variant="h6" gutterBottom>
        Complex Example (All Options)
      </Typography>
      <Grid container spacing={2}>
        <Grid item>
          <Button
            variant="contained"
            color="success"
            onClick={showComplexSuccess}
          >
            Full Featured
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ToastDemo;
